module.exports = __webpack_public_path__ + "static/media/icon_ayuda.93595ea0.svg";